<main class="main">
  <app-menu></app-menu>
  <div #content class="content">
    <div [class]="{ 'main-section-admin': isAdminPath(), 'main-section': !isAdminPath() }" >
      <router-outlet />
    </div>
  </div>
  <app-footer></app-footer>
</main>